import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=2332b21c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2332b21c')) {
      api.createRecord('2332b21c', component.options)
    } else {
      api.reload('2332b21c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=2332b21c&", function () {
      api.rerender('2332b21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A48QECIlpk76/JS/offershelp.vue"
export default component.exports